import CallsGraph from '@components/Calls'

function Calls() {
  return <CallsGraph />
}

export default Calls
